import { Navigate, lazyRouteComponent } from 'src/lib/routing';

import { RequireAuth } from 'containers/Auth/RequireAuth';

import type { RouteObject } from 'src/lib/routing';

const BuildFocusGroup = lazyRouteComponent(() => import('./BuildStudy/BuildFocusGroup'), 'BuildFocusGroup');
const FocusGroupContainer = lazyRouteComponent(() => import('./FocusGroupContainer'), 'FocusGroupContainer');
const MessagesContent = lazyRouteComponent(() => import('./Messages/MessagesContent'), 'MessagesContent');
const ParticipantsContent = lazyRouteComponent(() => import('./Recruit/ParticipantsContent'), 'ParticipantsContent');
const RecruitFocusGroup = lazyRouteComponent(() => import('./Recruit/RecruitFocusGroup'), 'RecruitFocusGroup');
const SettingsContent = lazyRouteComponent(() => import('./Recruit/SettingsContent'), 'SettingsContent');
const ScheduleFocusGroup = lazyRouteComponent(() => import('./Schedule/ScheduleFocusGroup'), 'ScheduleFocusGroup');

/**
 * Isolated route tree for the Labs focus-group experience. It sits alongside `/bookings/:id/*` and
 * `/studies/:id/*` rather than replacing either — an existing focus group keeps its current view
 * until someone opens this one deliberately.
 *
 * Every route below, including a direct URL into a child, renders through FocusGroupContainer, which
 * is where the Labs flag, booking permission and study-shape checks live.
 */
export const focusGroupRoutes: RouteObject[] = [
  {
    path: 'labs/focus-groups/:bookingId',
    element: (
      <RequireAuth>
        <FocusGroupContainer />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="schedule" replace /> },
      { path: 'build', element: <BuildFocusGroup /> },
      {
        path: 'recruit',
        element: <RecruitFocusGroup />,
        children: [
          { index: true, element: <Navigate to="participants" replace /> },
          { path: 'participants', element: <ParticipantsContent /> },
          // A saved filter is addressed the same way the classic participants table addresses it,
          // so `useParticipantsBasePath` and the shared save/rename/delete actions work unchanged.
          { path: 'participants/:segmentId', element: <ParticipantsContent /> },
          { path: 'settings', element: <SettingsContent /> },
        ],
      },
      { path: 'schedule', element: <ScheduleFocusGroup /> },
      // Inside this tree rather than a link to `/bookings/:id/messages`: that address renders
      // through BookingContainer, which redirects a flagged researcher's focus group back here.
      { path: 'messages', element: <MessagesContent /> },
    ],
  },
];
